export type ReminderHours = 'OneHour' | 'ThreeHour' | 'SixHour' | 'TenHour';
